import styled from 'styled-components';

const Heading = styled.div`
  color: #384076;
  font-size: 30px;
  font-weight: 500;
  font-family: 'Karla'
`;

export default Heading;



// WEBPACK FOOTER //
// ./client/shared/Heading.js